// Auto-generated file - do not edit manually
export const LOCALE_HASH = '8ab3ec95';
